import { Dialog, DialogProps } from "./Dialog";

export const VoiceDialog = (props: Omit<DialogProps, "title" | "children">) => {
  return (
    <Dialog {...props} title="Voice/Voicless, Plosives/Fricatives">
      <>
        <p>
          <b>Voiced consonant</b>: a consonant sound produced with vibration of
          the vocal cords. You can feel this vibration by placing your fingers
          on your throat while making the sound.
        </p>
        <p>
          The length of a vowel or sonorant (m,n,ng,l,r) depends on what
          follows. In order to sound authentically <i>English</i> we need to
          make sure that we are using the correct vowel or sonorant length.
          Consider the following examples:
        </p>
        <p>
          <b>Vowels: Leak, leaf, lead, leave, leaves</b>: As the consonant moves
          from voiceless plosive (k), to fricative (f), to voiced plosive (d),
          to voiced fricative (v, vz) becomes longer.
        </p>
        <p>
          <b>Sonorant: bent, bend; weld, belt; bard, bark (GenAm)</b>: As the
          consonant changes from a voiceless plosive (t) to a voiced plosive
          (d), the <i>n</i> becomes longer.
        </p>
        <p>
          In phonetics, this phenomenon is referred to{" "}
          <i>pre-fortis clipping</i> and
          <i>pre-lenis lengthening</i>.
        </p>
        <h5>Pre-Fortis Clipping</h5>
        <p>
          Pre = Before, Fortis = Voiceless (p, t, k, f, s, th, sh, ch), Clipping
          = Shortening <br />
          When a vowel or a sonorant (m,n,ng,l,r) is followed by a voiceless
          consonant, the vowel or sonorant is shortened.
        </p>
        <h5>Pre-Lenis Lengthening</h5>
        <p>
          Pre = Before, Lenis = Voiced (b, d, g, v, z, th, zh, dj, r, l),
          Lengthening = Becoming longer <br />
          When a vowel or a sonorant (m,n,ng,l,r) is followed by a voiced
          consonant or pause, the vowel or sonorant is lengthened.
        </p>
        <p>
          <b>Plosive</b>: blockage of air then release.
        </p>
        <p>
          <b>Fricative</b>: squeezing air between a small gap
        </p>
        <table>
          <thead>
            <tr>
              <th scope="col"></th>
              <th scope="col">Voiced</th>
              <th scope="col">Voiceless</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope="row">Plosives</th>
              <td>/b/ bat</td>
              <td>/p/ pit</td>
            </tr>
            <tr>
              <th scope="row"></th>
              <td>/d/ dog</td>
              <td>/t/ top</td>
            </tr>
            <tr>
              <th scope="row"></th>
              <td>/g/ go</td>
              <td>/k/ cat</td>
            </tr>
            <tr>
              <th scope="row">Fricatives</th>
              <td>/v/ save, of</td>
              <td>/f/ far</td>
            </tr>
            <tr>
              <th scope="row"></th>
              <td>/ð/ those</td>
              <td>/θ/ think</td>
            </tr>
            <tr>
              <th scope="row"></th>
              <td>/z/ zoo, rise</td>
              <td>/s/ sir, race</td>
            </tr>
            <tr>
              <th scope="row"></th>
              <td>/ʒ/ beige, Asia, pleasure</td>
              <td>/h/ ahead</td>
            </tr>
            <tr>
              <th scope="row"></th>
              <td></td>
              <td>/ʃ/ sharp, chef, pressure, sugar, motion</td>
            </tr>
          </tbody>
        </table>
      </>
    </Dialog>
  );
};
